import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import * as yup from "yup";
import { toastResponseError } from "../../../utils/responseMessageHelper";

export interface PrintUserPasswordFormValues {
  password: string;
  password_confirmation: string;
}

export const printUserPasswordFormHelper = (
  t: TFunction,
  submitAction: (data: any) => Promise<any>,
  closeRightPanel: () => void,
) => ({
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: false,
  initialValues: {
    password: "",
    password_confirmation: "",
  },
  validationSchema: yup.object().shape({
    password: yup
      .string()
      .required(t("error.required", { field: t("tools.password") })),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password")], t("error.passMatch"))
      .required(
        t("error.required", { field: t("tools.passwordConfirmation") }),
      ),
  }),
  onSubmit: (
    values: PrintUserPasswordFormValues,
    { setSubmitting }: FormikHelpers<PrintUserPasswordFormValues>,
  ) => {
    submitAction({
      external_print_user: {
        password: values.password,
        password_confirmation: values.password_confirmation,
      },
    })
      .then(() => closeRightPanel())
      .catch((response: string) => {
        toastResponseError(response);
      })
      .finally(() => setSubmitting(false));
  },
});
